import Swal from "sweetalert2";

import { configureOmiseSDK } from "./configureOmise";

export class GooglePayFlow {
	paymentAmount = null;
	data = null;
	googlePayPaymentData = null;
	initializeEpayment = async () => {
		throw new Error("initializeEpayment is required");
	};

	createOmiseCharge = async () => {
		throw new Error("initializeEpayment is required");
	};

	constructor({ paymentAmount, data, initializeEpayment, createOmiseCharge }) {
		this.paymentAmount = paymentAmount;
		this.data = data;
		if (!initializeEpayment) {
			throw new Error("initializeEpayment is required");
		}

		this.initializeEpayment = initializeEpayment;

		if (!createOmiseCharge) {
			throw new Error("createOmiseCharge is required");
		}

		this.createOmiseCharge = createOmiseCharge;
		configureOmiseSDK();
	}

	async init() {
		var omise_publicKey;
		if (window.location.href.includes("learn.sda.edu.sg")) {
			omise_publicKey = process.env.REACT_APP_OMISE_PKEY_PROD;
		} else {
			omise_publicKey = process.env.REACT_APP_OMISE_PKEY_UAT;
		}

		const paymentDataRequest = {
			apiVersion: 2,
			apiVersionMinor: 0,
			allowedPaymentMethods: [
				{
					type: "CARD",
					parameters: {
						allowedAuthMethods: ["PAN_ONLY"],
						allowedCardNetworks: ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"],
					},
					tokenizationSpecification: {
						type: "PAYMENT_GATEWAY",
						parameters: {
							gateway: "omise",
							gatewayMerchantId: omise_publicKey,
						},
					},
				},
			],
			transactionInfo: {
				countryCode: "SG",
				currencyCode: "SGD",
				totalPriceStatus: "FINAL",
				// set to cart total
				// totalPrice: '0.01'
				totalPrice: Number(this.paymentAmount).toFixed(2),
			},
			merchantInfo: {
				merchantName: "Skills Development Academy Pte Ltd",
				merchantId: window.location.href.includes("learn.sda.edu.sg")
					? "BCR2DN7T5CW6JQ2T"
					: undefined,
			},
		};

		let googlePaymentsClient = new window.google.payments.api.PaymentsClient({
			environment: window.location.href.includes("learn.sda.edu.sg") ? "PRODUCTION" : "TEST",
		});

		return googlePaymentsClient
			.loadPaymentData(paymentDataRequest)
			.then((paymentData) => {
				this.googlePayPaymentData = paymentData;
			})
			.catch(function (err) {
				console.warn("error", err);
				throw err;
			});
	}

	async processPayment() {
		await this.init();

		const paymentData = this.googlePayPaymentData;

		// show returned data in developer console for debugging
		// @todo pass payment token to your gateway to process payment
		let googlePayPaymentToken = paymentData.paymentMethodData.tokenizationData.token;

		console.log(googlePayPaymentToken);

		if (!googlePayPaymentToken) {
			throw new Error("Google Pay payment token not found");
		}

		const epaymentPayload = {
			...this.data,
			omiseToken: "",
			omiseSource: "",
			payment_method: "googlepay",
		};

		const serverRecord = await this.initializeEpayment(epaymentPayload);

		if (!serverRecord.status == 1) {
			throw new Error("Unexpected error while creating payment record, expecting 1");
		}

		const tokenParameters = {
			method: "googlepay",
			data: googlePayPaymentToken,
		};

		const omiseToken = await new Promise((resolve, reject) => {
			window.Omise.createToken("tokenization", tokenParameters, function (statusCode, response) {
				if (response.object == "error") {
					reject(response);
					Swal.fire({
						title: "",
						html:
							"Error: " +
							response.code
								.toLowerCase()
								.replace("_", " ")
								.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase()) +
							" - " +
							response.message
								.toLowerCase()
								.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase()),
						icon: "error",
					});
				} else {
					resolve(response.id);
				}
			});
		});

		const chargePayload = {
			payment_id: serverRecord.data.payment_id,
			payment_mode: serverRecord.data.payment_mode,
			omiseToken: omiseToken,
		};

		const chargeResult = await this.createOmiseCharge(chargePayload);
		if (chargeResult.status == 2) {
			window.location.href = chargeResult.url;
		}
	}
}
